<div>
  <mat-form-field appearance="outline" style="margin-top: 12px">
    <mat-label>Weather Layer</mat-label>
    <mat-select
      placeholder="Weather Layer"
      [value]="selectedWeatherBaseMapLayerSignal()"
      (selectionChange)="updateSelectedWeatherBaseMapLayer($event.value)"
    >
      <mat-option *ngFor="let option of openWeatherBaseMapLayers" [value]="option.layer">
        {{ option.formLabel }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
<div>
  <mat-form-field appearance="outline">
    <mat-label>Choose a date</mat-label>
    <input
      matInput
      [matDatepicker]="picker"
      [matDatepickerFilter]="dateRestrictionFilter"
      [value]="selectedDateSignal()"
      (dateChange)="updateSelectedDate($event.value)"
    />
    <mat-datepicker-toggle matIconSuffix [for]="picker" />
    <mat-datepicker #picker />
  </mat-form-field>
</div>
<div>
  <mat-form-field appearance="outline">
    <mat-label>Hour</mat-label>
    <mat-select
      placeholder="Hour"
      [value]="selectedHourSignal()"
      (selectionChange)="updateSelectedHour($event.value)"
    >
      <mat-option *ngFor="let hour of hours" [value]="hour">
        {{ hour }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Minutes</mat-label>
    <mat-select
      placeholder="Minutes"
      [value]="selectedMinutesSignal()"
      (selectionChange)="updateSelectedMinutes($event.value)"
    >
      <mat-option *ngFor="let minute of minutes" [value]="minute">
        {{ minute }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
